function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.33331 0C4.76376 0 2.66666 2.14994 2.66666 4.78423V6.15116H1.33333C0.596665 6.15116 0 6.76286 0 7.51808V15.7196C0 16.4748 0.596665 17.0865 1.33333 17.0865H13.3333C14.07 17.0865 14.6666 16.4748 14.6666 15.7196V7.51808C14.6666 6.76286 14.07 6.15116 13.3333 6.15116H12V4.78423C12 2.236 10.0244 0.183554 7.57029 0.0493908C7.4949 0.0182556 7.41458 0.00151671 7.33331 0ZM7.33331 1.36692C9.18242 1.36692 10.6666 2.88854 10.6666 4.78423V6.15116H3.99999V4.78423C3.99999 2.88854 5.48421 1.36692 7.33331 1.36692Z",
  fill: "currentColor"
});

function SvgIconLockTiny(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLockTiny);
export default __webpack_public_path__ + "static/media/icon-lock-tiny.43e2578d.svg";
export { ForwardRef as ReactComponent };